import { useUserConfig } from '@/hooks/user/use-user-config';

export const useUserDesktop = (uuid: string) => {
  const { data } = useUserConfig();

  return (
    data?.userConfig.desktops.find((desktop) => desktop.uuid === uuid) || 
    data?.organisationConfig.desktops.find((desktop) => desktop.uuid === uuid)
  )
}